export default __webpack_public_path__ + "static/media/units-mark.58d22015.svg";